import { fetchJson } from '@/clients/util/xhr';
import { useAuth, useSignIn } from '@clerk/clerk-react';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import styles from './login-styles.module.css';

export function SectionTokenPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || {};
  const { signIn, setActive } = useSignIn();
  const { isSignedIn } = useAuth();

  const loginTokenBody = { token };
  const loginQuery = useQuery({
    queryKey: ['login-token'],
    queryFn: async () => fetchJson(`api/user/login`, loginTokenBody, false),
  });

  useEffect(() => {
    if (!signIn || !setActive || loginQuery.isLoading) {
      return;
    }

    const createSignIn = async () => {
      try {
        // Create the `SignIn` with the token
        if (!loginQuery.data?.token?.token) {
          return;
        }

        if (isSignedIn) {
          return navigate('/');
        }

        const signInAttempt = await signIn.create({
          strategy: 'ticket',
          ticket: loginQuery.data.token.token as string,
        });

        // If the sign-in was successful, set the session to active
        if (signInAttempt.status === 'complete') {
          await setActive({
            session: signInAttempt.createdSessionId,
          });
        }
      } catch (err) {
        console.error('Error:', JSON.stringify(err, null, 2));
      } finally {
        navigate('/');
      }
    };

    createSignIn();
  }, [
    signIn,
    setActive,
    loginQuery.isLoading,
    isSignedIn,
    loginQuery.data?.token?.token,
    navigate,
  ]);

  return <div className={styles['login-page']}></div>;
}
